import { computed } from 'vue';
import { useViewModeStore } from '@/stores/viewModeStore';
import { useClientCompaniesStore } from '@/stores/clientCompaniesStore';
import { useClientProjectsStore } from '@/stores/clientProjectsStore';
import { useAdminProjectsStore } from '@/stores/adminProjectsStore';
import { useAdminCompaniesStore } from '@/stores/adminCompaniesStore';
import { useAdminCalendarStore } from '@/stores/adminCalendarStore';
import { useClientCalendarStore } from '@/stores/clientCalendarStore';

export function useStoreSelector() {
  const viewModeStore = useViewModeStore();
  const clientCompaniesStore = useClientCompaniesStore();
  const clientProjectsStore = useClientProjectsStore();
  const adminProjectsStore = useAdminProjectsStore();
  const adminCompaniesStore = useAdminCompaniesStore();
  const adminCalendarStore = useAdminCalendarStore();
  const clientCalendarStore = useClientCalendarStore();

  const activeStores = computed(() => {
    const isClientView = viewModeStore.isImpersonating;
    
    return {
      companyStore: isClientView ? clientCompaniesStore : adminCompaniesStore,
      projectStore: isClientView ? clientProjectsStore : adminProjectsStore,
      calendarStore: isClientView ? clientCalendarStore : adminCalendarStore,
      viewMode: isClientView ? 'client' : 'admin',
      isImpersonating: viewModeStore.isImpersonating
    };
  });

  return {
    activeStores,
    viewModeStore
  };
} 